import { render, staticRenderFns } from "./PersonalInfoPage.vue?vue&type=template&id=aa64f7a6&scoped=true"
import script from "./PersonalInfoPage.vue?vue&type=script&lang=js"
export * from "./PersonalInfoPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoPage.vue?vue&type=style&index=0&id=aa64f7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa64f7a6",
  null
  
)

export default component.exports